import React from 'react';
import PropTypes from 'prop-types';

import Styles from './FormWrapper.styles';

const FormWrapper = ({ children }) => (
  <div className={Styles.default}>
    {children}
  </div>
);

FormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormWrapper;
